const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTreatmentOutcomes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.8,
    height: 26,
    viewBox: "0 0 20.8 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 26H2.587A2.6 2.6 0 0 1 0 23.4L.013 2.6A2.6 2.6 0 0 1 2.6 0H13l7.8 7.8v15.6a2.6 2.6 0 0 1-2.6 2.6zm-13-10.4v2.6h3.9v3.9h2.6v-3.9h3.9v-2.6h-3.9v-3.9H9.1v3.9zm6.5-13.65V9.1h7.15z",
    style: {
      fill: "#002d72"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatmentOutcomes);
export default __webpack_public_path__ + "static/media/TreatmentOutcomes.8c7a952733b94dde4ce2578e3381eeaa.svg";
export { ForwardRef as ReactComponent };